import { useQuery } from '@tanstack/react-query';
import { jobPositionService } from '../services/jobPosition.service';

interface UseJobPositionSuggestionsResult {
  data: string[] | undefined;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  error: Error | null;
}

export function useJobPositionSuggestions(
  field: string,
  query: string
): UseJobPositionSuggestionsResult {
  const result = useQuery({
    queryKey: ['job-position-suggestions', field, query],
    queryFn: () => jobPositionService.getSuggestions({ field, query }),
    enabled: query.length >= 3,
    staleTime: 60_000,
  });

  return {
    data: result.data,
    isLoading: result.isLoading,
    isError: result.isError,
    isSuccess: result.isSuccess,
    error: result.error,
  };
}
